<template>
  <the-animations />
</template>
